import { render, staticRenderFns } from "./SearchExpireProduct.vue?vue&type=template&id=cb67c9ee&scoped=true&"
import script from "./SearchExpireProduct.vue?vue&type=script&lang=js&"
export * from "./SearchExpireProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb67c9ee",
  null
  
)

export default component.exports